import { apiClient } from '../../api/client';
import { otmetitSvoyNabor } from './svoyNabor';

/** The random owner belongs to this mounted pult, never to local/session storage. */
export async function reserveManualEntry(owner: string, active: boolean): Promise<void> {
  await apiClient.post('/telephony/workplace/nabor/reserve', { owner, active });
}
export async function callManualEntry(owner: string, phone: string, lineId: number): Promise<void> {
  otmetitSvoyNabor();
  await apiClient.post('/telephony/workplace/nabor/nomer', { owner, phone, line_id: lineId });
}
